module.exports = __webpack_public_path__ + "static/img/list_banner.0abfa6dd.png";